module.exports = __webpack_public_path__ + "img/reply.0b600f2c.svg";